import { createStandardAction } from 'typesafe-actions';

export const addCartItem = createStandardAction('CART_ADD')<void>();

export const removeCartItem = createStandardAction('CART_REMOVE')<void>();

export const updateCartCount = createStandardAction('CART_UPDATE_COUNT')<
  number
>();

export const toggleCart = createStandardAction('CART_TOGGLE')<void>();
